import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import { getVistaPresupuestosInternosCanceladosList } from '../../helpers/user_mv';
import helpers from '../../mixins/helpers';

const state = {
    presupuestos: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    /* Filtro */
    filtroNumero: false,
    fechaDesde: moment(new Date()).add(-60, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    numero: 0,
    cliente: null,
    contacto: null,
    accion: '',
    numeroPO: '',
    sortByDescending: true,

    vistaPresupuestosCancelados: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.presupuestos = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;
        
        state.filtroNumero = false;
        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.numero = 0;
        state.cliente = null;
        state.contacto = null;
        state.accion = '';
        state.numeroPO = '';
        state.sortByDescending = true;
    
        state.vistaPresupuestosCancelados = [];
    },

    'INICIALIZAR_PRESUPUESTOS' (state) {
        state.presupuestos = [];
    },
    'SET_PRESUPUESTOS' (state, presupuestos) {
        state.presupuestos = presupuestos;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
    'SET_VISTA_PRESUPUESTOS' (state, vistaPresupuestosCancelados) {
        state.vistaPresupuestosCancelados = vistaPresupuestosCancelados;
    }
};

const getters = {
    getField,
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getPresupuestos ( { commit } ) {
        return new Promise((resolve, reject) => {

            commit('INICIALIZAR_PRESUPUESTOS');
            
            let url = 'presupuestosinternos/cancelados';

            let queryString = 'pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            if ((/true/i).test(state.filtroNumero)) {
                queryString = '?numero=' + state.numero;
            } else {
                queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');

                if (state.cliente) {
                    if (state.cliente.id != 0) {
                        queryString += '&clienteId=' + state.cliente.id;
                    }
                }
                if (state.contacto) {
                    if (state.contacto.id != 0) {
                        queryString += '&contactoId=' + state.contacto.id;
                    }
                }
                if (state.accion.trim() != '') {
                    queryString += '&accion=' + state.accion.trim();
                }
                if (state.numeroPO.trim() != '') {
                    queryString += '&numeroOrdenCompra=' + state.numeroPO.trim();
                }
            }

            queryString += '&sortByDescending='+ state.sortByDescending;
                
            apiAxios.get(url + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        let paginationParams = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', paginationParams);
                    }

                    commit('SET_VISTA_PRESUPUESTOS', getVistaPresupuestosInternosCanceladosList());

                    commit('SET_PRESUPUESTOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}